// extracted by mini-css-extract-plugin
export default {"delete":"DeleteModal_delete__Y6tRN","text":"DeleteModal_text__ukYks","btns":"DeleteModal_btns__6Nb2q"};